export const SMS_CONFIGURATIONS_RESET_STATE = 'SMS_CONFIGURATIONS_RESET_STATE';
export const SMS_CONFIGURATIONS_CURRENT_ITEM = 'SMS_CONFIGURATIONS_CURRENT_ITEM';
 
export const SMS_CONFIGURATIONS_REQUEST_LOADING = 'SMS_CONFIGURATIONS_REQUEST_LOADING';
export const SMS_CONFIGURATIONS_REQUEST_SUCCESS = 'SMS_CONFIGURATIONS_REQUEST_SUCCESS';
export const SMS_CONFIGURATIONS_REQUEST_FAILED = 'SMS_CONFIGURATIONS_REQUEST_FAILED';
 
export const SMS_CONFIGURATIONS_CURRENT_ACTION = 'SMS_CONFIGURATIONS_CURRENT_ACTION';
export const SMS_CONFIGURATIONS_RESET_ACTION = 'SMS_CONFIGURATIONS_RESET_ACTION';